import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'transfer-form',
    templateUrl: './transfer-form.component.html',
    styleUrls: ['./transfer-form.component.scss'],
    standalone: false
})
export class TransferFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  operation: string;
  optionsReasons: { id: string; label: string }[] = [
    {
      id: 'SUIVI',
      label: 'Le suivi de votre contrat',
    },
    {
      id: 'GESTION',
      label: 'La gestion de votre contrat',
    },
    {
      id: 'FISCALITE',
      label: 'La fiscalité de votre contrat',
    },
  ];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    const { operation } = pledge || {};
    this.operation = operation;
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
